import { configureStore } from '@reduxjs/toolkit';
import cartReducer from './slices/cartSlice'; // ✅ Update with your slice name

const store = configureStore({
  reducer: {
    cart: cartReducer,
  },
});

export default store;
